import {
  CriteriaRequest,
  Filter,
  Order,
  OrderType,
} from '@daas-consulting/core-cross-interfaces';

export interface QueryParams {
  [param: string]:
    | string
    | number
    | boolean
    | ReadonlyArray<string | number | boolean>;
}

export function mapCriteriaToParams(
  criteria: Partial<CriteriaRequest>
): QueryParams {
  const aux = new Map();
  const sortAux = _resolveOrderBy(criteria?.orderBy);
  const sort = sortAux
    .map((x) => `${x.field.trim()} ${x.type.trim()}`)
    .join(',');
  aux.set('sort', sort);

  if (typeof criteria?.pageIndex === 'number' && criteria?.pageIndex >= 0) {
    aux.set('pageIndex', criteria.pageIndex);
  }

  if (typeof criteria?.pageSize === 'number' && criteria?.pageSize > 0) {
    aux.set('pageSize', criteria?.pageSize);
  }

  const filters = _resolveFilters(criteria?.filters);
  const filter = filters.reduce((acc, cur) => {
    const value =
      cur.value instanceof Date
        ? JSON.stringify(cur.value).replace(/('|")*/gi, '')
        : cur.value;
    acc.set(cur.key, value);
    return acc;
  }, aux);
  const rv = { ...Object.fromEntries(filter) };
  return rv;
}

function _resolveFilters(filters: Filter[] | object | undefined): Filter[] {
  let rv: Filter[] = [];
  if (Array.isArray(filters)) {
    rv = filters;
  } else if (typeof filters === 'object' && filters !== null) {
    const obj = filters as { [key: string]: unknown };
    rv = Object.keys(obj).map((key) => ({
      key,
      value: obj[key],
    }));
  }

  return rv;
}

function _resolveOrderBy(
  orderBy: Order[] | object | string | undefined
): Order[] {
  let rv: Order[] = [];
  if (Array.isArray(orderBy)) {
    rv = (orderBy as Order[]).reduce((acc, cur) => {
      acc.push(
        ...cur.field.split(',').map((y) => ({ field: y, type: cur.type }))
      );
      return acc;
    }, [] as Order[]);
  } else if (typeof orderBy === 'object' && orderBy !== null) {
    rv = Object.keys(orderBy).map((key) => ({
      field: key,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: (orderBy as any)[key],
    }));
  } else if (typeof orderBy === 'string') {
    rv = orderBy
      .split(',')
      .map((x) => {
        const aux = x.trim();
        if (aux) {
          const match = /([a-zA-Z_][a-zA-Z0-9_]*)\s*(asc|desc)?/i.exec(x);
          if (match) {
            const field = match[1].trim();
            const type: OrderType =
              typeof match[2] === 'string'
                ? (match[2].trim().toLocaleLowerCase() as OrderType)
                : 'asc';
            const ret: Order = {
              field: field,
              type: type,
            };
            return ret;
          }
        }

        return null;
      })
      .filter((x): x is Order => typeof x === 'object' && x !== null);
  }

  return rv;
}
